import { createUseStyles } from 'react-jss'

export default createUseStyles({
  title: {
    fontSize: '20px',
    fontWeight: '700'
  },
  subtitle: {
    fontSize: '18px',
    marginBottom: '8px',
    fontWeight: '500'
  },
  dateTime: {
    display: 'flex',
    fontSize: '16px',
    justifyContent: 'space-between'
  },
  bodyContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  label: {
    fontSize: '18px'
  },
  text: {
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  header: {
    paddingBottom: '10px'
  },
  image: {
    width: '100%',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '10px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px'
  }
})
